const parseSessionJson = (key, fallback = null) => {
  const rawValue = sessionStorage.getItem(key);
  if (!rawValue) return fallback;

  try {
    return JSON.parse(rawValue);
  } catch {
    return fallback;
  }
};

const cleanValue = (value) => {
  if (value === null || value === undefined || value === 'undefined' || value === 'null') {
    return '';
  }
  return value;
};

export const getCompanyToken = (companyInfo) =>
  cleanValue(
    companyInfo?.validCompanyToken ??
      companyInfo?.token ??
      companyInfo?.companyToken ??
      '',
  );

export const getCompanyBaseURL = (companyInfo) =>
  cleanValue(companyInfo?.baseURL ?? '');

export const getStoredCompanyInfo = () => parseSessionJson('companyInfo', null);

export const getCurrentCompanyInfo = (userInfo) =>
  userInfo?.companyInfo || getStoredCompanyInfo();

export const persistCompanySession = (companyInfo) => {
  const nextCompanyInfo = companyInfo || {};
  sessionStorage.setItem('companyInfo', JSON.stringify(nextCompanyInfo));
  sessionStorage.setItem('baseURL', getCompanyBaseURL(nextCompanyInfo));
  sessionStorage.setItem('validCompanyToken', getCompanyToken(nextCompanyInfo));
};
